/**
 * A digit run that is an amount: four digits or more, and not part of a date or a clock
 * (`1403/05/12`, `12:30`) — those are written as they are, not grouped.
 */
const AMOUNT_PATTERN = /(?<![\d/:.-])\d{4,}(?![\d/:.-])/g;

/** The text a server message carries, with the amounts in it grouped by thousands. */
export function groupMessageAmounts(text: string): string {
	return text.replace(AMOUNT_PATTERN, amount => amount.replace(/\B(?=(\d{3})+(?!\d))/g, ','));
}
